import React from "react";
import Categories from "@/shared/components/photo_gallery/containers/categories";
import Gallery from "@/shared/components/photo_gallery/containers/gallery";
import Modal from "@/shared/components/photo_gallery/containers/modal";

const App = () => (
  <React.Fragment>
    <Categories />
    <Gallery />
    <Modal />
  </React.Fragment>
);

export default App;
